<template>
	<div class="recaptcha-container" @mouseover="hover = true" @mouseleave="hover = false">
		<div
			class="recaptcha"
			v-if="!hover"
		>
			<div class="conteudo-interno">
				<div class="area-icone">
					<svg
						viewBox="0 -0.04 600 598.59"
						xmlns="http://www.w3.org/2000/svg"
						width="40"
						height="40"
					>
						<path
							d="M600 298.83c-.01-4.3-.11-8.58-.31-12.84V43.06l-67.12 67.16C477.64 42.93 394.06-.04 300.46-.04c-97.42 0-183.96 46.52-238.67 118.57l110.02 111.25a145.91 145.91 0 0 1 44.57-50.04c19.21-14.99 46.43-27.26 84.07-27.26 4.55 0 8.06.54 10.64 1.54 46.65 3.68 87.08 29.44 110.89 66.82l-77.88 77.93c98.64-.39 210.08-.62 255.89.05"
							fill="#1c3aa9"
						/>
						<path
							d="M298.71-.03c-4.31.02-8.58.12-12.84.31H43.07l67.13 67.16C42.95 122.41 0 206.02 0 299.68c0 97.47 46.5 184.07 118.51 238.8L229.69 428.4a145.737 145.737 0 0 1-50-44.59c-14.99-19.22-27.25-46.45-27.25-84.12 0-4.55.53-8.07 1.53-10.65 3.69-46.67 29.43-87.12 66.79-110.94l77.88 77.92c-.39-98.7-.62-210.2.05-256.04"
							fill="#4285f4"
						/>
						<path
							d="M.01 299.68c.02 4.3.12 8.58.31 12.84v242.93l67.12-67.16c54.94 67.29 138.51 110.26 232.12 110.26 97.41 0 183.95-46.52 238.66-118.57L428.2 368.73c-10.78 19.96-26.1 37.09-44.57 50.04-19.21 14.99-46.42 27.26-84.07 27.26-4.55 0-8.06-.54-10.64-1.54-46.64-3.68-87.08-29.44-110.88-66.82l77.88-77.93c-98.65.39-210.08.62-255.9-.05"
							fill="#ababab"
						/>
					</svg>

					<div class="texto-imagem">
						<span>Privacidade</span> - <span>Termos</span>
					</div>
				</div>
			</div>
		</div>

		<transition name="abrindo">
			<div
				class="recaptcha-hover"
				v-if="hover"
			>
				<div class="conteudo-interno">
					<div class="area-icone">
						<svg
							viewBox="0 -0.04 600 598.59"
							xmlns="http://www.w3.org/2000/svg"
							width="40"
							height="40"
						>
							<!-- O mesmo SVG reutilizado -->
							<path
								d="M600 298.83c-.01-4.3-.11-8.58-.31-12.84V43.06l-67.12 67.16C477.64 42.93 394.06-.04 300.46-.04c-97.42 0-183.96 46.52-238.67 118.57l110.02 111.25a145.91 145.91 0 0 1 44.57-50.04c19.21-14.99 46.43-27.26 84.07-27.26 4.55 0 8.06.54 10.64 1.54 46.65 3.68 87.08 29.44 110.89 66.82l-77.88 77.93c98.64-.39 210.08-.62 255.89.05"
								fill="#1c3aa9"
							/>
							<path
								d="M298.71-.03c-4.31.02-8.58.12-12.84.31H43.07l67.13 67.16C42.95 122.41 0 206.02 0 299.68c0 97.47 46.5 184.07 118.51 238.8L229.69 428.4a145.737 145.737 0 0 1-50-44.59c-14.99-19.22-27.25-46.45-27.25-84.12 0-4.55.53-8.07 1.53-10.65 3.69-46.67 29.43-87.12 66.79-110.94l77.88 77.92c-.39-98.7-.62-210.2.05-256.04"
								fill="#4285f4"
							/>
							<path
								d="M.01 299.68c.02 4.3.12 8.58.31 12.84v242.93l67.12-67.16c54.94 67.29 138.51 110.26 232.12 110.26 97.41 0 183.95-46.52 238.66-118.57L428.2 368.73c-10.78 19.96-26.1 37.09-44.57 50.04-19.21 14.99-46.42 27.26-84.07 27.26-4.55 0-8.06-.54-10.64-1.54-46.64-3.68-87.08-29.44-110.88-66.82l77.88-77.93c-98.65.39-210.08.62-255.9-.05"
								fill="#ababab"
							/>
						</svg>
					</div>

					<div class="conteudo-texto">
						<span class="titulo">protegido por reCAPTCHA</span>
						<span class="links">
							<a
								class="links-a"
								href="https://policies.google.com/privacy?hl=pt-BR"
								target="_blank"
							>
								Privacidade
							</a>
							-
							<a
								class="links-a"
								href="https://policies.google.com/terms?hl=pt-BR"
								target="_blank"
							>
								Termos
							</a>
						</span>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			hover: false,
		};
	},
};
</script>

<style scoped>
.abrindo-enter-active {
	animation: efeitoAbrindo 0.2s ease-out forwards;
}

.abrindo-leave-active {
	animation: efeitoFechando 0.2s ease-out forwards;
}

@keyframes efeitoAbrindo {
	from {
		transform: translateX(100%);
		opacity: 1;
	}
	to {
		transform: translateX(0);
		opacity: 1;
	}
}

@keyframes efeitoFechando {
	from {
		transform: translateX(0);
		opacity: 1;
	}
	to {
		transform: translateX(72%);
		opacity: 1;
	}
}

.recaptcha {
	position: fixed;
	right: 0;
	bottom: 30px;
	width: 70px;
	height: 60px;
	background-color: #f9f9f9;
	border: 1px solid #8d8d8d86;
	border-radius: 3px;
	box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.08);
	margin-right: -2px;
}

.conteudo-interno {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	height: 100%;
}

.recaptcha-hover {
	position: fixed;
	right: 0;
	bottom: 30px;
	width: 256px;
	height: 60px;
	margin-right: -2px;
	background-color: #1a73e8;
	box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.08);
	border-radius: 3px;
}

.area-icone {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	background-color: #f9f9f9;
	border: 1px solid #8d8d8d86;
	height: 100%;
	width: 70px;
	box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.08);
}

.texto-imagem {
	font-size: 5px;
	line-height: 6px;
	margin-top: 3px;
	color: #000000;
}

.conteudo-texto {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding-left: 12px;
}

.titulo {
	font-size: 11px;
	color: #fff;
	font-size: 13px;
	font-weight: 400;
}

.links {
	font-size: 10px;
	color: #fff;
}

.links-a {
	font-size: 10px;
	color: #fff;
}

.links-a:hover {
	font-size: 10px;
	color: #fff;
	text-decoration: underline;
}
</style>
